module.exports = __webpack_public_path__ + "img/Dantam Makeover 13.30cc4699.jpg";